import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));

// Add the link tag for fonts to the head section
const link = document.createElement('link');
link.href = 'https://fonts.googleapis.com/css2?family=Font1|Font2&display=swap';
link.rel = 'stylesheet';
document.head.appendChild(link);
